var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('p',[_vm._v("Colas")]),_c('activity-overview',{attrs:{"type":_vm.type,"moduleType":_vm.moduleType}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }